import { render, staticRenderFns } from "./ReviewRequestSingle.vue?vue&type=template&id=10645504"
import script from "./ReviewRequestSingle.vue?vue&type=script&lang=js"
export * from "./ReviewRequestSingle.vue?vue&type=script&lang=js"
import style0 from "./ReviewRequestSingle.vue?vue&type=style&index=0&id=10645504&prod&lang=css"
import style1 from "./ReviewRequestSingle.vue?vue&type=style&index=1&id=10645504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports